import styled from 'styled-components';

import {Delete} from "lucide-react";
import React from "react";
import {useStoreProfile} from "../../store";
import {FixedTopBar} from "../../components/top_bar";
import {WhiteMain} from "../../components/main";
import {useActions} from "../../app_context";

const User = styled.div``;
const Unblock = styled.div``;
const BlockHelp = styled.div`
  margin-top: 32px;
  text-align: center;
h2 {
  font-weight: 500;
}
p {
  margin: 12px 32px;
}`;
const BlockList = styled(({blocked, className}) => {

    const actions = useActions();
    const {blocked_communities} = useStoreProfile();
    const handleDelete = async (value) => {
        await actions.settingsChanged({
            blocked_communities: blocked_communities.filter((item) => {
                return item !== value;
            })
        });
    };

    return (
        <div className={className}>
            {blocked?.map((community) =>
                <User key={community}>
                    {community}
                    <Unblock onClick={() => handleDelete(community)}>
                        <Delete size={20} />
                    </Unblock>
                </User>
            )}
        </div>
    );
})`
  color: ${({theme}) => theme.menu.color};
  ${User} {
    display: flex;
    padding: 12px 20px;
    font-size: 16px;
  }
  ${Unblock} {
    margin-left: auto;
    padding: 0 8px;
  }
`;

const BlockedCommunities = ({className}) => {

    const {blocked_communities} = useStoreProfile();

    return (
        <>
            <FixedTopBar back title="Blocked Communities" border={false}/>
            <WhiteMain className={className}>
                {(blocked_communities && blocked_communities.length > 0) ?
                    <BlockList blocked={blocked_communities} />
                    :
                    <BlockHelp>
                        <h2>
                            You haven't blocked any communities.
                        </h2>
                        <p>
                            If you want to block a community, you can tap the three dots alongside a post on Trending to find the block option.
                        </p>
                    </BlockHelp>
                }
            </WhiteMain>
        </>
    );
};

export default BlockedCommunities;
